"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AnimatedContainer = function (_a) {
    var viewKey = _a.viewKey, _b = _a.durationMs, durationMs = _b === void 0 ? 280 : _b, children = _a.children;
    var outerRef = (0, react_1.useRef)(null);
    var innerRef = (0, react_1.useRef)(null);
    var _c = (0, react_1.useState)("auto"), height = _c[0], setHeight = _c[1];
    var _d = (0, react_1.useState)(false), animating = _d[0], setAnimating = _d[1];
    var measure = function () {
        var _a, _b;
        var h = (_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0;
        setHeight(h);
    };
    (0, react_1.useLayoutEffect)(function () {
        measure();
    }, []);
    (0, react_1.useEffect)(function () {
        if (!innerRef.current)
            return;
        var ro = new ResizeObserver(function () {
            if (!animating)
                setHeight(innerRef.current.offsetHeight);
        });
        ro.observe(innerRef.current);
        return function () { return ro.disconnect(); };
    }, [animating]);
    (0, react_1.useEffect)(function () {
        if (innerRef.current) {
            setHeight(innerRef.current.offsetHeight);
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    if (!innerRef.current)
                        return;
                    setAnimating(true);
                    setHeight(innerRef.current.offsetHeight);
                    var timer = setTimeout(function () {
                        setAnimating(false);
                        setHeight("auto");
                    }, durationMs);
                    return function () { return clearTimeout(timer); };
                });
            });
        }
    }, [viewKey, durationMs]);
    return (react_1.default.createElement("div", { ref: outerRef, style: {
            position: "relative",
            overflow: "hidden",
            height: height,
            transition: "height ".concat(durationMs, "ms cubic-bezier(.2,.8,.2,1)"),
            willChange: "height",
        } },
        react_1.default.createElement("div", { key: viewKey, ref: innerRef, style: {
                animation: "fadeSlideIn ".concat(durationMs, "ms ease both"),
            } }, children),
        react_1.default.createElement("style", null, "\n        @keyframes fadeSlideIn {\n          from { opacity: .001; transform: translateY(6px); }\n          to   { opacity: 1;    transform: translateY(0); }\n        }\n        @media (prefers-reduced-motion: reduce) {\n          div[style*=\"fadeSlideIn\"] { animation: none !important; }\n        }\n      ")));
};
exports.default = AnimatedContainer;
